export enum RiskLevel {
    LOW,
    MODERATE,
    VERY_HIGH,
}
